import { normalizeText, convertNotionalToBRL } from './convertNotionalToBRL.js'

export function isNegotiated(row) {
  const status = normalizeText(row.status)
  return status === 'NOTH.DONE' || status === 'DEAL'
}

// Sum of BRL notional for negotiated rows only (DEAL + NOTH.DONE).
// effectiveSpotByRow must come from createEffectiveSpotMap(allRows).
export function calculateNegotiatedVolumeBRL(rows, effectiveSpotByRow) {
  return rows.reduce((total, row) => {
    if (!isNegotiated(row)) return total

    const amount = convertNotionalToBRL(row, effectiveSpotByRow.get(row))

    if (amount == null) return total

    return total + amount
  }, 0)
}

// Quantas linhas caem no universo negociado.
export function countNegotiated(rows) {
  return rows.reduce((n, row) => (isNegotiated(row) ? n + 1 : n), 0)
}

// Ticket medio negociado: volume BRL dividido pela contagem do MESMO universo.
// Fica aqui, e nao no chamador, porque a guarda de divisao por zero seria
// duplicada entre o KPI e o measureKpis do benchmark.
export function calculateNegotiatedTicketBRL(rows, effectiveSpotByRow) {
  const count = countNegotiated(rows)
  return count > 0 ? calculateNegotiatedVolumeBRL(rows, effectiveSpotByRow) / count : 0
}
